import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  UPDATE_TEAM,
  GET_TEAMS,
  GET_TEAM,
  GET_TEAMS_BY_MANAGER_ID,
} from "../../GraphQL/Teams";
import useNotification from "../../hooks/useNotification.js";
import ManagerSelect from "../../Components/Manager/ManagerSelect";

const EditTeamDialog = (props) => {
  const [team, setTeam] = useState(props.team);
  const [manager, setManager] = useState(null);
  const { notifySuccess } = useNotification();

  useEffect(() => {
    setTeam(props.team);
  }, [props]);

  const isValid = !!(team?.name?.trim());

  const [updateTeam, { loading, error }] = useMutation(UPDATE_TEAM, {
    variables: {
      id: props.team.id,
      managerId: manager,
      name: team.name,
    },
    refetchQueries: [GET_TEAMS, GET_TEAM, GET_TEAMS_BY_MANAGER_ID],
    onCompleted: () => { notifySuccess("Team updated."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isValid) {
            updateTeam();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Team"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <ManagerSelect
            managers={props.managers}
            manager={manager}
            setManager={setManager}
          />
          <TextField
            data-testid="name"
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={props.team.name}
            onChange={(e) => setTeam({ ...team, name: e.target.value })}
            inputProps={{ maxLength: 20 }}
            helperText={`${team?.name?.length ?? 0}/20`}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveEditTeamDialogButton"
            variant="contained"
            onClick={() => updateTeam()}
            disabled={loading || !isValid}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Update"
            )}
          </Button>
          <Button
            data-testid="closeEditTeamDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default EditTeamDialog;
